import { Component, OnInit } from '@angular/core';
import { SeoService } from '@app/core/seo/seo.service';

@Component({
    standalone: false,
    selector: 'app-ws-privacy',
    templateUrl: './ws-privacy.component.html'
    // .legal styles are global (styles.scss imports pages/legal.scss) so the prerendered shell matches
})
export class WsPrivacyComponent implements OnInit {
    constructor(private seo: SeoService) { }

    ngOnInit(): void {
        this.seo.set({
            title: 'Privacy policy',
            description: 'How the ESZES website handles the data you send through its contact and Snapcart access-request forms, sign-in for the free edition, and the third-party services it uses.',
            path: '/privacy'
        });
    }
}
